import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router';
import { Modal } from './Modal';
import { RichContent } from './RichContent';
import type { NotificationMessageFormat } from '../services/notificationApiService';

export interface NotificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    messageFormat?: NotificationMessageFormat;
    notificationId?: string;
    linkUrl?: string | null;
}

export const NotificationModal: React.FC<NotificationModalProps> = ({
    isOpen,
    onClose,
    title,
    message,
    messageFormat,
    notificationId,
    linkUrl,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleLinkClick = () => {
        if (linkUrl) {
            onClose();
            navigate(linkUrl);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} showCloseButton>
            <div style={{
                padding: theme.spacing.lg,
                whiteSpace: messageFormat === 'html' ? 'normal' : 'pre-wrap',
                wordBreak: 'break-word',
                lineHeight: 1.5,
                color: theme.colors.text.primary,
            }}>
                <RichContent message={message} messageFormat={messageFormat} notificationId={notificationId} navigate={navigate} />
            </div>
            {linkUrl && (
                <div style={{
                    padding: theme.spacing.lg,
                    paddingTop: 0,
                    borderTop: `1px solid ${theme.colors.border.default}`,
                    marginTop: theme.spacing.sm,
                }}>
                    <button
                        type="button"
                        onClick={handleLinkClick}
                        style={{
                            padding: `${theme.spacing.sm} ${theme.spacing.md}`,
                            backgroundColor: theme.colors.primary,
                            color: theme.colors.text.inverse || '#fff',
                            border: 'none',
                            borderRadius: theme.borderRadius.sm,
                            fontSize: theme.typography.fontSize.sm,
                            fontWeight: theme.typography.fontWeight.medium,
                            cursor: 'pointer',
                        }}
                    >
                        View
                    </button>
                </div>
            )}
        </Modal>
    );
};
